<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>

  <div class="ya-bottomsheet-content-center">
    <div class="ya-bottomsheet-title-icon">
      <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-achtung"></div>
    </div>

    <!-- Titel -->
    <h2 [langkey]="addressVerificationData.title"></h2>

    <!-- Inhalt -->
    <div class="announce_content">

      <!-- Compare-Block nur wenn compare vorhanden -->
      <ng-container *ngIf="addressVerificationData && addressVerificationData.compare; else noCompare">
        <!-- Eingabe -->
        <div><b langkey="phAddressCompare_YourInput_Label"></b></div>

        <div>
          <span [class.diff]="addressVerificationData.compare.entered.line1.isDifferent">
            {{ addressVerificationData.compare.entered.line1.text }}
          </span>
        </div>

        <div>
          <span [class.diff]="addressVerificationData.compare.entered.line2.isDifferent">
            {{ addressVerificationData.compare.entered.line2.text }}
          </span>
        </div>

        <br />

        <!-- Vorschlag -->
        <div><b langkey="phAddressCompare_SuggestedAddress_Label"></b></div>

        <div>
          <span [class.diff]="addressVerificationData.compare.suggested.line1.isDifferent">
            {{ addressVerificationData.compare.suggested.line1.text }}
          </span>
        </div>

        <div>
          <span [class.diff]="addressVerificationData.compare.suggested.line2.isDifferent">
            {{ addressVerificationData.compare.suggested.line2.text }}
          </span>
        </div>
      </ng-container>

      <!-- Fallback wenn compare fehlt -->
      <ng-template #noCompare>
        <span langkey="phUserProfileAddress_VerifyUnavailable_Content"></span>
      </ng-template>

    </div>

    <!-- Buttons (immer da) -->
    <div class="buttonscontainer">
      <div class="ya-button-container">
        <button mat-flat-button (click)="firstBtnClick()">
          <span [langkey]="addressVerificationData.firstBtnLabel"></span>
        </button>
      </div>

      <div class="ya-button-container">
        <button mat-flat-button (click)="secondBtnClick()">
          <span [langkey]="addressVerificationData.secondBtnLabel"></span>
        </button>
      </div>

      <div class="ya-button-container" *ngIf="addressVerificationData.thirdBtnLabel">
        <button mat-flat-button (click)="thirdBtnClick()">
          <span [langkey]="addressVerificationData.thirdBtnLabel"></span>
        </button>
      </div>
    </div>

  </div>
</div>